// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_PROJECT_CHARTS_DATA = "GET_PROJECT_CHARTS_DATA";
export const GET_PROJECTSTATUS_CHARTS_DATA = "GET_PROJECTSTATUS_CHARTS_DATA";
